var exports = {
  "iE": "EmbedCard.module__wrapper___bHpTZX",
  "p_": "EmbedCard.module__splashWrapper___bHpTZX",
  "Yi": "EmbedCard.module__splash___bHpTZX",
  "Vg": "EmbedCard.module__grid___bHpTZX",
  "iA": "EmbedCard.module__iconSlot___bHpTZX",
  "Qs": "EmbedCard.module__content___bHpTZX",
  "wx": "EmbedCard.module__header___bHpTZX",
  "$": "EmbedCard.module__titleRow___bHpTZX",
  "VA": "EmbedCard.module__subtitle___bHpTZX",
  "rf": "EmbedCard.module__body___bHpTZX",
  "yF": "EmbedCard.module__divider___bHpTZX",
  "DD": "EmbedCard.module__title___bHpTZX",
  "N4": "EmbedCard.module__titleButton___bHpTZX",
  "jn": "EmbedCard.module__titlePrimary___bHpTZX",
  "S3": "EmbedCard.module__titleDanger___bHpTZX",
  "BK": "EmbedCard.module__helpText___bHpTZX",
  "_O": "EmbedCard.module__iconCircleDisabled___bHpTZX",
  "m5": "EmbedCard.module__iconError___bHpTZX",
  "qV": "EmbedCard.module__skeleton___bHpTZX",
  "U6": "EmbedCard.module__pulse___bHpTZX",
  "mj": "EmbedCard.module__skeletonCircle___bHpTZX",
  "Iz": "EmbedCard.module__skeletonTitle___bHpTZX",
  "wS": "EmbedCard.module__skeletonSubtitle___bHpTZX",
  "VR": "EmbedCard.module__skeletonIcon___bHpTZX",
  "X1": "EmbedCard.module__skeletonDot___bHpTZX",
  "gH": "EmbedCard.module__skeletonStat___bHpTZX",
  "Ye": "EmbedCard.module__skeletonStatShort___bHpTZX",
  "KJ": "EmbedCard.module__skeletonStatLong___bHpTZX",
  "G3": "EmbedCard.module__skeletonButton___bHpTZX",
};

module.exports = exports;
